import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';

import { useGetRecord } from 'root/admin/components/hooks';
import { Title, Thumbnail } from 'root/admin/components';

import store from 'root/admin/store';
import { Form, Field, Loader } from '@smartplatform/ui';
import { Editor } from '../../components';

const EditAward = ({ match, rootPath, tabName, setShowMenuItems }) => {
	const { id } = match.params;
	const options = { include: ['years'] };
	const record = useGetRecord({ model: 'Award', id, options, tabName });

	useEffect(() => {
		store.ui.setPage('');
	}, []);

	if (!record) {
		return <Loader />;
	}

	const onSave = record => {
		if (isNaN(id)) {
			store.history.push(`${rootPath}/${record.id}`);
		} else {
			store.history.push(rootPath);
		}
	};

	return (
		<div>
			<Title record={record} name="Награда" />
			<Form record={record} rootPath={rootPath} stay onSave={record => onSave(record)}>
				<Field property="name" label="Название" />
				{/*<Button*/}
				<Field property="content" label="Описание">
					<Editor height={600} />
				</Field>
				<Thumbnail record={record} label="Изображение награды" />
			</Form>
		</div>
	);
};

export default withRouter(EditAward);
